// 旧网银生产地址
export const corporbankUrl = 'https://ebank.cbibank.com/corporbank'

// 旧网银备用生产地址
export const corporbankUrlBackUp = 'https://ebank.cbibservice.com/corporbank'

// 新网银生产地址
export const webCorporbankUrl = 'https://online.cbibank.com'

// 新网银备用生产地址
export const webCorporbankUrlBackup = 'https://online.cbibservice.com'
